// extracted by mini-css-extract-plugin
export default {"profileCompleteButtonText":"styles_profileCompleteButtonText__SEWNu"};